/**
 * PDF Templates REST origin from Vite env (Azure Key Vault uses hyphenated name; local .env uses underscores).
 */
export function readPdfTemplatesApiOriginEnv(): string {
  const underscore = (import.meta.env['VITE_PDF_TEMPLATES_API_BASE_URL'] as string | undefined)?.trim() ?? '';
  const hyphen = (import.meta.env['VITE-PDF-TEMPLATES-API-BASE-URL'] as string | undefined)?.trim() ?? '';
  return (underscore || hyphen).replace(/\/+$/, '');
}
